<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import Vue from "vue";
import smoothscroll from "smoothscroll-polyfill";
import VButton from "@/components/ui/VButton";
import VFlex from "@/components/ui/VFlex";
import VContainer from "@/components/ui/VContainer";
import VRow from "@/components/ui/VRow";
import VColumn from "@/components/ui/VColumn";
import { ladderVue } from "@@/services/ladder";
import store from "@/store";
import "@/services/segment";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfo, faQuestion } from "@fortawesome/free-solid-svg-icons";
import {
    faAdjust,
    faAngleDown,
    faTimes
} from "@fortawesome/pro-regular-svg-icons";
import {
    faComments,
    faTasks,
    faChartLine
} from "@fortawesome/pro-duotone-svg-icons";
import {
    faFacebookF,
    faInstagram,
    faApple,
    faAndroid,
    faTwitter,
    faYoutube
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
    faInfo,
    faAdjust,
    faFacebookF,
    faInstagram,
    faApple,
    faAndroid,
    faTwitter,
    faYoutube,
    faComments,
    faTasks,
    faChartLine,
    faAngleDown,
    faQuestion,
    faTimes
);

// Install our app wide components
Vue.component("fa-icon", FontAwesomeIcon);
Vue.component("VButton", VButton);
Vue.component("VFlex", VFlex);
Vue.component("VContainer", VContainer);
Vue.component("VRow", VRow);
Vue.component("VColumn", VColumn);
Vue.component("VCol", VColumn);

// Install our API so it's accessible in components via this.$ladder
Vue.use(ladderVue);

// Setup the smooth scroll polyfill
smoothscroll.polyfill();

export default {
    name: "App",
    data() {
        return {
            shared: store.state
        };
    },
    beforeCreate() {
        // If there is an auth token, fetch the current user
        if (this.$ladder.getAuthToken()) {
            this.$ladder.me().then(me => {
                store.setUser(me);
            });
        }
    }
};
</script>

<style lang="scss">
@import "@/assets/styles/app.scss";
</style>
